import { cleanupObject } from '.';
import { getAPIUrl } from '../helpers/App';
import { isCollectionsPage } from '../helpers/Collections';

export const APIgetCollection = (collectionUuid, params) => (
  window.axios.get(getAPIUrl(`/collections/${collectionUuid}`), { params })
    .then(response => (response))
);

export const APIgetCollectionsList = params => (
  window.axios.get(getAPIUrl('/collections/list'), { params })
    .then(response => (response))
);

export const APIupdateCollection = ({ collection }) => (
  window.axios.patch(getAPIUrl(`/collections/${collection.uuid}`), { collection: cleanupObject(collection) })
    .then(response => (response))
);

export const APIdeleteCollections = ({
  collectionUuidList,
  progressCollectionsUuid,
  progressFilesUuid,
  withFiles = false,
}) => (
  window.axios.post(getAPIUrl('/collections/remove'), {
    collectionUuidList,
    progressCollectionsUuid,
    progressFilesUuid,
    withFiles,
  }).then(response => (response))
);

export const APIdeleteCollectionsPermanent = ({
  collectionUuidList,
  progressCollectionsUuid,
  progressFilesUuid,
  withFiles = false,
}) => (
  window.axios.post(getAPIUrl('/collections/remove_permanent'), {
    collectionUuidList,
    progressCollectionsUuid,
    progressFilesUuid,
    withFiles,
  }).then(response => (response))
);

export const APIrestoreCollections = ({
  collectionUuidList,
  parentCollectionUuid,
  withFiles = false,
}) => (
  window.axios.post(getAPIUrl('/collections/restore'), {
    collectionUuidList,
    parentCollectionUuid,
    withFiles,
  }).then(response => (response))
);

export const APIaddFilesToCollection = (collectionUuid, {
  files,
  fileGroupUuid,
  selectedAllFiles,
  filters,
}) => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/add`), {
    files,
    file_group_uuid: fileGroupUuid,
    selected_all: !!selectedAllFiles,
    filters,
  })
    .then(response => (response))
);

export const APImoveFilesToCollection = (collectionUuid, {
  files,
  fileParams,
  sourceCollectionUuid,
  fileGroupUuid,
  selectedAllFiles,
  filters,
}) => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/add`), {
    files,
    fileParams,
    source_collection_uuid: sourceCollectionUuid,
    file_group_uuid: fileGroupUuid,
    selected_all: !!selectedAllFiles,
    filters,
  })
    .then(response => (response))
);

export const APIremoveFilesFromCollection = (collectionUuid, {
  files,
  fileParams,
  fileGroupUuid,
  selectedAllFiles,
  filters,
  progressGroupUuid,
}) => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/remove`), {
    files,
    fileParams,
    file_group_uuid: fileGroupUuid,
    selected_all: !!selectedAllFiles,
    filters,
    progress_group_uuid: progressGroupUuid,
  })
    .then(response => (response))
);

export const APIgetCollectionGroups = params => (
  window.axios.get(getAPIUrl('/collectiongroups'), { params })
    .then(response => (response))
);

export const APIgetCollectionGroup = collectionGroupId => (
  window.axios.get(getAPIUrl(`/collectiongroups/${collectionGroupId}`))
    .then(response => (response))
);

export const APIcreateCollectionGroup = collectiongroup => (
  window.axios.post(getAPIUrl('/collectiongroups'), { collectiongroup })
    .then(response => (response))
);

export const APIupdateCollectionGroup = collectiongroup => (
  window.axios.patch(getAPIUrl(`/collectiongroups/${collectiongroup.id}`), {
    collectiongroup: cleanupObject(collectiongroup, ['collections', 'image', 'imagesq']),
  })
    .then(response => (response))
);

export const APIdeleteCollectionGroup = (collectionGroupId, params) => (
  window.axios.delete(getAPIUrl(`/collectiongroups/${collectionGroupId}`), { params })
    .then(response => (response))
);

export const APIgetCollections = (collectionGroupId, params) => {
  if (isCollectionsPage()) {
    if (window.getFilesRequestCancel !== null) {
      window.getFilesRequestCancel.cancel('Operation canceled due to new request.');
      window.getFilesRequestCancel = null;
    }
    if (window.getFiltersRequestCancel !== null) {
      window.getFiltersRequestCancel.cancel('Operation canceled due to new request.');
      window.getFiltersRequestCancel = null;
    }
  }
  if (window.getCollectionsRequestCancel !== null) {
    window.getCollectionsRequestCancel.cancel('Operation canceled due to new request.');
  }
  window.getCollectionsRequestCancel = window.axios.CancelToken.source();

  if (collectionGroupId && collectionGroupId > 0) {
    return window.axios.get(getAPIUrl(`/collectiongroups/${collectionGroupId}/collections`), {
      cancelToken: window.getCollectionsRequestCancel.token,
      params,
    })
      .then(response => (response));
  }
  return window.axios.get(getAPIUrl('/collections'), {
    cancelToken: window.getCollectionsRequestCancel.token,
    params,
  })
    .then(response => (response));
};

export const APIcreateCollection = collection => (
  window.axios.post(getAPIUrl('/collections'), { collection })
    .then(response => (response))
);

export const APIupdateFilesOrder = (collectionUuid, files) => (
  window.axios.patch(getAPIUrl(`/collections/${collectionUuid}/files_order`), { files })
    .then(response => (response))
);

export const APIupdateCollectionsOrder = (collectionUuid, collections) => {
  if (collectionUuid) {
    return window.axios.patch(getAPIUrl(`/collections/${collectionUuid}/collections_order`), { collections })
      .then(response => (response));
  }
  return window.axios.patch(getAPIUrl('/collections/collections_order'), { collections })
    .then(response => (response));
};

export const APIupdateCollectionOwner = (collectionUuid, userUuid, recurring) => (
  window.axios.patch(getAPIUrl(`/collections/${collectionUuid}/owner`), { user_uuid: userUuid, recurring })
    .then(response => (response))
);

export const APImoveCollections = ({
  parentCollectionUuid,
  collections,
  selectedAllCollections,
  filters,
  progressGroupUuid,
}) => (
  window.axios.patch(getAPIUrl('/collections/move'), {
    parent_uuid: parentCollectionUuid,
    collections,
    selected_all: !!selectedAllCollections,
    filters,
    progress_group_uuid: progressGroupUuid,
  })
    .then(response => (response))
);

export const APIgetCollectionLikes = collectionUuid => (
  window.axios.get(getAPIUrl(`/collections/${collectionUuid}/likes`))
    .then(response => (response))
);

export const APIlikeCollection = collectionUuid => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/likes`))
    .then(response => (response))
);

export const APIunlikeCollection = collectionUuid => (
  window.axios.delete(getAPIUrl(`/collections/${collectionUuid}/likes`))
    .then(response => (response))
);

export const APIgetCollectionsWithPermissions = collections => (
  window.axios.post(getAPIUrl('/collections/permissions'), { collections })
    .then(response => (response))
);

export const APIupdateCollectionPermissions = (collection, spreadPermissions) => (
  window.axios.patch(getAPIUrl(`/collections/${collection.uuid}/permissions`), {
    collection,
    spread_permissions: spreadPermissions,
  })
    .then(response => (response))
);

export const APIarchiveCollection = (collectionUuid, params = {}) => (
  window.axios.patch(getAPIUrl(`/collections/${collectionUuid}/archive`), params)
    .then(response => (response))
    .catch(error => (error))
);

export const APIunarchiveCollection = (collectionUuid, params = {}) => (
  window.axios.patch(getAPIUrl(`/collections/${collectionUuid}/unarchive`), params)
    .then(response => (response))
    .catch(error => (error))
);

export const APIsetCollectionFeaturedImage = (collectionUuid, fileUuid) => (
  window.axios.patch(getAPIUrl(`/collections/${collectionUuid}/featured_image`), {
    file_uuid: fileUuid,
  })
    .then(response => (response))
    .catch(error => (error))
);

export const APIarchiveCollectionGroup = collectionGroupId => (
  window.axios.patch(getAPIUrl(`/collectiongroups/${collectionGroupId}/archive`))
    .then(response => (response))
    .catch(error => (error))
);

export const APIunarchiveCollectionGroup = collectionGroupId => (
  window.axios.patch(getAPIUrl(`/collectiongroups/${collectionGroupId}/unarchive`))
    .then(response => (response))
    .catch(error => (error))
);

export const APIupdateCollectionGroupPermissions = collectionGroup => (
  window.axios.patch(getAPIUrl(`/collectiongroups/${collectionGroup.id}/permissions`), {
    collection_group: collectionGroup,
  })
    .then(response => (response))
);

export const APIgetCollectionGroupsWithPermissions = collectionGroups => (
  window.axios.post(getAPIUrl('/collectiongroups/permissions'), { collection_groups: collectionGroups })
    .then(response => (response))
);

export const APIupdateCollectionGroupsPositions = positions => (
  window.axios.patch(getAPIUrl('/collectiongroups/positions'), { positions })
    .then(response => (response))
);

export const APIupdateCollectionGroupsGroupPositions = positions => (
  window.axios.patch(getAPIUrl('/collectiongroups/group_positions'), { positions })
    .then(response => (response))
);

export const APIupdateCollectionGroupGroupsPositions = positions => (
  window.axios.patch(getAPIUrl('/collectiongroupgroups/positions'), { positions })
    .then(response => (response))
);

export const APIcreateCollectionGroupGroup = ({ collectionGroupGroup }) => (
  window.axios.post(getAPIUrl('/collectiongroupgroups'), { collectiongroupgroup: collectionGroupGroup })
    .then(response => (response))
);

export const APIupdateCollectionGroupGroup = ({ collectionGroupGroup }) => (
  window.axios.patch(getAPIUrl(`/collectiongroupgroups/${collectionGroupGroup.id}`), { collectiongroupgroup: collectionGroupGroup })
    .then(response => (response))
);

export const APIdeleteCollectionGroupGroup = groupId => (
  window.axios.delete(getAPIUrl(`/collectiongroupgroups/${groupId}`))
    .then(response => (response))
);

let getCollectionsTreeRequestCancel = null;
export const APIgetCollectionsTree = (p) => {
  const params = Object.assign({}, p);
  delete params.source;
  if (getCollectionsTreeRequestCancel !== null) {
    getCollectionsTreeRequestCancel.cancel('Operation canceled due to new request.');
  }
  getCollectionsTreeRequestCancel = window.axios.CancelToken.source();
  return window.axios.get(getAPIUrl(`/collections/tree${params.parentUuid ? `/${params.parentUuid}` : ''}`), {
    cancelToken: getCollectionsTreeRequestCancel.token,
    params,
  })
    .then(response => (response));
};

export const APIgetFeaturedCollections = params => (
  window.axios.get(getAPIUrl('/collections/featured'), { params })
    .then(response => (response))
);

export const APIcreateFolderCollections = params => (
  window.axios.post(getAPIUrl('/collections/folders'), params)
    .then(response => (response))
);

export const APIsubscribeCollection = collectionUuid => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/subscription`))
    .then(response => (response))
);

export const APIunsubscribeCollection = collectionUuid => (
  window.axios.delete(getAPIUrl(`/collections/${collectionUuid}/subscription`))
    .then(response => (response))
);

export const APIgetCollectionsSummary = ({ collectionUuidList }) => (
  window.axios.post(getAPIUrl('/collections/summary'), {
    collectionUuidList,
  })
    .then(response => (response))
);

export const APIduplicateCollection = ({
  parentCollectionUuid,
  collectionName,
  collectionUuidList,
  includeFiles,
}) => (
  window.axios.post(getAPIUrl('/collections/duplicate'), {
    parent_uuid: parentCollectionUuid,
    collection_name: collectionName,
    collection_uuid_list: collectionUuidList,
    include_files: includeFiles,
  })
    .then(response => (response))
);

export const APIcheckExistingFiles = (collectionUuid, paths) => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/files`), { paths })
    .then(response => (response))
);

export const APIsyncCollection = (collectionUuid) => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/sync`))
    .then(response => (response))
);

export const APIunsyncCollection = (collectionUuid) => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/unsync`))
    .then(response => (response))
);

export const APIgetSyncedCollections = (params) => (
  window.axios.get(getAPIUrl('/collections/synced'), { params })
    .then(response => (response))
);

export const APIconvertCollectionToRegular = (collectionUuid) => (
  window.axios.post(getAPIUrl(`/collections/${collectionUuid}/convert_to_regular`))
    .then(response => (response))
);
